<div class="customer-service-info">
  <div class="customer-service-row">
    <img src="assets/images/customer-service/customer-service-1.png" alt="Account Manager Icon" />
    <img src="assets/images/customer-service/customer-service-2.png" alt="Account Manager Icon" />
    <img src="assets/images/customer-service/customer-service-3.png" alt="Account Manager Icon" />
    <img src="assets/images/customer-service/customer-service-4.png" alt="Account Manager Icon" />
  </div>

  @if (showContact()) {
    <div class="customer-service-contact">
      <p class="body-default">{{ accountManager.name }}</p>
      <a
        class="body-default"
        rel="noopener"
        mkpDataTest="manager-email"
        [href]="'mailto:' + accountManager.email"
      >
        <ui-asset name="mail" />
        <span>
          {{ accountManager.email }}
        </span>
      </a>
    </div>
  }
</div>
